export enum PeriodontalExaminationChartFields {
  periodontalCase = 'periodontalCase',
  maxillaryValues = 'maxillaryValues',
  mandibularValues = 'mandibularValues',
  calculusCheckIndex = 'calculusCheckIndex',
  bleedingCheckIndex = 'bleedingCheckIndex',
  maxillaryDrawing = 'maxillaryDrawing',
  mandibularDrawing = 'mandibularDrawing',
}

export const chartDefaultValues = {
  calculus: [],
  probing: [],
  bleeding: [],
};

export enum PeriodontalCase {
  simple = 'simple',
  complex = 'complex',
}

export const PeriodontalCaseLabel = {
  [PeriodontalCase.simple]: 'Simple',
  [PeriodontalCase.complex]: 'Complex',
};

export const PeriodontalExaminationChartFormDefaultValues = {
  [PeriodontalExaminationChartFields.periodontalCase]: undefined,
  [PeriodontalExaminationChartFields.maxillaryValues]: chartDefaultValues,
  [PeriodontalExaminationChartFields.mandibularValues]: chartDefaultValues,
  [PeriodontalExaminationChartFields.calculusCheckIndex]: null,
  [PeriodontalExaminationChartFields.bleedingCheckIndex]: null,
  [PeriodontalExaminationChartFields.maxillaryDrawing]: '',
  [PeriodontalExaminationChartFields.mandibularDrawing]: '',
};
